import React, { type FunctionComponent, useCallback, useEffect, useMemo, useState } from "react";
import { companyInfo0 } from "@/data/PosSettingsSignal.ts";
import { getApiUrl } from "@/shared/utils.ts";
import { toast } from "react-toastify";
import { GoogleMap, Marker, OverlayView, Polygon } from "@react-google-maps/api";
import axios from "axios";
import { onlineOrder0, onlineOrders1 } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { useAsyncEffect, useSignal } from "@/react/core/reactive.ts";
import _ from "lodash";
import MenuDetailCard from "@delivery-management/DeliveyMangement/MenuDetailCard.tsx";
import {
  backToMyLocation,
  defaultLocation,
  defaultZoom,
  deliverySettingsZone,
  getCoordCustomer,
  getInfoPolygon,
  mapContainerStyle,
  mapInstance,
  myLocation,
  polygonInfo,
  polygons,
  setMapInstance,
  setMyLocation,
  zoomIn,
  zoomOut,
} from "@/react/DeliveryManagementView/google-map-logic.ts";
import DetailZoneCard from "@delivery-management/DeliveyMangement/DetailZoneCard.tsx";
import { deliveryMode, setDeliverySetting0 } from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";

export type RadiusFormType = {
  type?: 'viewOrder' | 'editZone';
  isViewOneOrder?: boolean; // Thêm prop isViewOneOrder
};

const ViewMap: FunctionComponent<RadiusFormType> = ({ type, isViewOneOrder = false }) => {
  const [mapCenter, setMapCenter] = useState<any>();
  const countryAlpha2Code = useMemo(() => companyInfo0()?.country?.toUpperCase(), []);
  const [ordersWithPosition, setOrdersWithPosition] = useSignal<any[]>([]);
  const [currentOrder, setCurrentOrder] = useState<any>();
  const [customerPosition, setCustomerPosition] = useState<{ lat: number; lng: number } | undefined>(undefined);
  const [isOpenCustomerMenu, setIsOpenCustomerMenu] = useState<boolean>(false);
  const [isOpenPolygonMenu, setIsOpenPolygonMenu] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const openPolygonMenu = useCallback(() => {
    setIsOpenPolygonMenu(true)
  }, []);
  const closePolygonMenu = useCallback(() => {
    setIsOpenPolygonMenu(false)
  }, []);
  const openCustomerMenu = useCallback(() => {
    setIsOpenCustomerMenu(true)
  }, []);
  const closeCustomerMenu = useCallback(() => {
    setIsOpenCustomerMenu(false)
    setCurrentOrder(undefined)
    closePolygonMenu()
  }, []);

  const handleMarkerClick = useCallback((e: google.maps.MapMouseEvent, order: any) => {
    if (e.latLng) {
      setCustomerPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      setCurrentOrder(order)
      openCustomerMenu()
    }
  }, []);

  useEffect(() => {
    if (companyInfo0()?.address && !myLocation()) {
      (async () => {
        try {
          setIsLoading(true)
          console.log("call api/map/coords, params is: ", {
            countryAlpha2Code,
            code: companyInfo0()?.zipCode,
            searchPlace: companyInfo0()?.address
          })
          const { data: coord } = await axios.get(getApiUrl() + "/api/map/coords", {
            params: { countryAlpha2Code, code: companyInfo0()?.zipCode, searchPlace: companyInfo0()?.address }
          });
          console.log(countryAlpha2Code, `API location for ${companyInfo0()?.address} is:`, coord);
          setMyLocation(coord);
        } catch (geoError) {
          console.warn("Geolocation failed, trying API:", geoError);
          toast.error("Error getting location, fallback to default location");
          setMyLocation(defaultLocation);
        } finally {
          setIsLoading(false)
        }
      })();
    }
  }, [companyInfo0()?.address, countryAlpha2Code]);

  useAsyncEffect(async () => {
    setIsLoading(true)
    if (type === 'editZone') return setIsLoading(false)
    if (!onlineOrders1()?.length) return setIsLoading(false)
    const orders = onlineOrders1()
    const resultOrders = []
    for (const order of orders) {
      if (isViewOneOrder && onlineOrder0()?.customerRaw?.address) {
        const _order = onlineOrder0()
        const position = await getCoordCustomer(_order.customerRaw)
        if (position) {
          const { lat, lng } = position
          console.log(`vi tri cua customer ${_order.customerRaw?.name} la: `, { lat, lng })
          _.assign(_order, { lat: lat, lng: lng })
          resultOrders.push(_order)
          break
        }
      } else if (!_.isEmpty(order.customerRaw)) {
        console.log(`dang lay vi tri cua customer ${order.customerRaw.name}`)
        const position = await getCoordCustomer(order.customerRaw)
        if (position) {
          const { lat, lng } = position
          console.log(`vi tri cua customer ${order.customerRaw.name} la: `, { lat, lng })
          _.assign(order, { lat: lat, lng: lng })
          resultOrders.push(order)
        }
      }
    }
    console.log(`marker length ${resultOrders.length}`)
    setOrdersWithPosition(resultOrders);
    setIsLoading(false)
  }, [onlineOrders1()?.length]);

  return (
    <>
      {(!isLoading && myLocation()?.latitude) ? (
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={mapCenter}
              zoom={defaultZoom}
              onLoad={(map) => {
                console.log('GoogleMap [onLoad] success')
                setMapInstance(map)
                setMapCenter({
                  lat: isViewOneOrder ? onlineOrder0()?.lat : myLocation().latitude,
                  lng: isViewOneOrder ? onlineOrder0()?.lng : myLocation().longitude
                }); // Chỉ set 1 lần khi map load
                setIsLoading(false)
              }}
              onClick={closeCustomerMenu}
              onZoomChanged={() => {
                console.log('zoom changed', mapInstance()?.getZoom());
              }}
              options={{
                mapId: 'DEMO_MAP_ID',
                fullscreenControl: false, // Tắt chế độ xem toàn màn hình
                streetViewControl: false, // Tắt control Street View mặc định (nút Pegman)
                zoomControl: false, // Tắt các nút zoom mặc định
                mapTypeControl: false, // Tắt menu chuyển đổi bản đồ/vệ tinh
                clickableIcons: false, // Tắt hiển thị thông tin khi nhấp vào địa danh
              }}
            >
              {deliveryMode() === 'zone' && polygons()?.length > 0 && polygons().map((polygon, index) => (
                <Polygon
                  key={index}
                  paths={polygon.path}
                  onClick={(e) => {
                    if (isOpenPolygonMenu) {
                      closePolygonMenu();
                    } else {
                      console.log("[openPolygonMenu]")
                      getInfoPolygon(polygon, { lat: e.latLng?.lat()!, lng: e.latLng?.lng()! })
                      openPolygonMenu()
                      const zone = deliverySettingsZone().find(s => s._id === polygon.zoneRef);
                      if (zone) {
                        setDeliverySetting0(zone)
                      }
                    }
                  }}
                  options={polygon.options} />
              ))}
              <Marker
                position={{ lat: myLocation().latitude, lng: myLocation().longitude }}
                icon={{
                  url: "/iconhome-location@2x.png",
                  scaledSize: new window.google.maps.Size(60, 60),
                }}
              />
              {isViewOneOrder && (
                onlineOrder0()?.lat && onlineOrder0()?.lng ? (
                  <Marker
                    position={{ lat: onlineOrder0()?.lat, lng: onlineOrder0()?.lng }}
                    icon={{
                      url: "/icondriver@2x.png",
                      scaledSize: new window.google.maps.Size(50, 50),
                    }}
                    onClick={(e) => handleMarkerClick(e, onlineOrder0())}
                  />
                ) : (
                  <div className="absolute top-2 left-2 bg-red-500 text-white p-2 rounded">
                    Invalid address
                  </div>
                )
              )}

              {/* Nếu có chế độ xem menu khách hàng */}
              {isOpenCustomerMenu && (
                <OverlayView position={customerPosition} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                  <MenuDetailCard order={currentOrder} />
                </OverlayView>
              )}
              {deliveryMode() === 'radius' && ordersWithPosition()?.length > 0 && ordersWithPosition().map((order, index) => (
                <Marker
                  key={index}
                  position={{ lat: order.lat, lng: order.lng }}
                  icon={{
                    url: "/icondriver@2x.png",
                    scaledSize: new window.google.maps.Size(50, 50),
                  }}
                  onClick={(e) => {
                    if (isOpenCustomerMenu) {
                      closeCustomerMenu();
                    } else {
                      handleMarkerClick(e, order)
                    }
                  }}
                />
              ))}
              {isOpenCustomerMenu &&
                <OverlayView
                  position={customerPosition}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <MenuDetailCard order={currentOrder} />
                </OverlayView>
              }
              {isOpenPolygonMenu &&
                <OverlayView
                  position={{ lat: polygonInfo()?.location?.lat!, lng: polygonInfo()?.location?.lng! }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <DetailZoneCard zone={polygonInfo()} />
                </OverlayView>
              }
              <div className="absolute bottom-2 right-2 flex flex-col gap-1">
                <button onClick={() => {
                  backToMyLocation(myLocation())
                }} className="p-1 bg-white border-[2px]">
                  🔘
                </button>
                <button onClick={zoomIn} className="p-1 bg-white border-[2px]">
                  ➕
                </button>
                <button onClick={zoomOut} className="p-1 bg-white border-[2px]">
                  ➖
                </button>
              </div>
            </GoogleMap>
        ) :
        <div className="w-full h-full flex items-center justify-center">
          <div
            className="animate-spin loader ease-linear rounded-full border-2 border-t-white border-slate-400 h-10 w-10"></div>
        </div>
      }
    </>
  );
};

export default ViewMap;
